import Behaviour, { mix, DomEvents } from '@/core';
import SponSlide from 'spon-slide';
import eventPromise from '@/utils/eventPromise';
import animationEnd from '@/utils/animationEnd';

export default class NewsCarousel extends mix(Behaviour).with(DomEvents) {
	mounted = () => {
		const slide = new SponSlide(this.$el, {
			loop: true,
			selector: '[data-slide-item]',
			activeClass: 'hero--home__item--current',
			dots: false,
			delay: 5000,
			promiseBefore: true,
		});

		const event = animationEnd('transition');

		// const $pagers = [...this.$el.querySelectorAll('[data-slide-link]')]

		// $pagers[0].classList.add('is-current')

		slide.init();

		slide.on('spon:before', ({ props: { currentEl, nextEl }, resolve }) => {
			// eslint-disable-next-line
			[...nextEl.querySelectorAll('[data-slide-text]')].forEach($item => {
				$item.classList.add('is-to-enter');
			});

			this.$el.classList.add('is-animating');

			Promise.all(
				[...currentEl.querySelectorAll('[data-slide-text]')].map($item =>
					eventPromise(event, $item, () => {
						$item.classList.add('is-to-leave');
					}),
				),
			).then(resolve);
		});

		slide.on('spon:after', ({ currentEl, nextEl }) => {
			// eslint-disable-next-line
			[...nextEl.querySelectorAll('[data-slide-text]')].forEach($item => {
				$item.classList.remove('is-to-enter');
			});
			[...currentEl.querySelectorAll('[data-slide-text]')].forEach($item => {
				$item.classList.remove('is-to-leave');
			});
			this.$el.classList.remove('is-animating');
		});

		// slide.on('spon:change', ({ currentIndex, newIndex }) => {
		// 	$pagers[currentIndex].classList.remove('is-current')
		// 	$pagers[newIndex].classList.add('is-current')
		// })

		/*
      This function must be called to bind the events
    */
		this.addDomEvents();
	};

	events = {
		'click [data-close-update]': () => {
			const $newsFlash = this.$el.querySelector('.c-news-flash');
			$newsFlash.remove();
		},
	};
}
